
import LinkSquare from "../../../assets/filled/LinkSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LinkSquareIcon({ className, dataTestid = "LinkSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LinkSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
